import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const ThankYouSection: React.FC = () => {
  const { themeConfig } = useTheme();

  return (
    <section className={`${themeConfig.layout?.sectionStyle} min-h-screen flex items-center justify-center`}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-2xl mx-auto"
      >
        {/* Success Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="mb-8"
        >
          <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
            <svg
              className="w-10 h-10 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </motion.div>

        {/* Thank You Message */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-4xl font-bold text-[var(--color-primary)] mb-4"
        >
          Thank You!
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-xl text-[var(--color-text)] mb-8"
        >
          Your message has been sent successfully. I'll get back to you as soon as possible!
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center"
        >
          <a
            href="/#contact"
            className={`inline-block px-6 py-3 rounded-md bg-[var(--color-primary)] text-white font-medium ${themeConfig.animation?.transition} ${themeConfig.animation?.hover}`}
          >
            Send Another Message
          </a>
          <a
            href="/"
            className={`inline-block px-6 py-3 rounded-md border border-[var(--color-primary)] text-[var(--color-primary)] font-medium ${themeConfig.animation?.transition} hover:bg-[var(--color-primary)] hover:text-white`}
          >
            Back to Home
          </a>
        </motion.div>

        {/* Additional Info */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-12 pt-8 border-t border-[var(--color-secondary)]"
        >
          <p className="text-sm text-[var(--color-text)] opacity-70 mb-4">
            You should also receive an automated confirmation email shortly.
          </p>
          <div className="flex justify-center space-x-6">
            <a
              href="mailto:sharmachaitanya945@gmail.com"
              className="text-sm text-[var(--color-primary)] hover:underline"
            >
              sharmachaitanya945@gmail.com
            </a>
            <a
              href="https://linkedin.com/in/chaitanya-sharma-9b7b1b2a2"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[var(--color-primary)] hover:underline"
            >
              LinkedIn
            </a>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default ThankYouSection;
